
  import { getPartnerList } from '~/api/about/index.js'
  import AboutSubHeader from '~/components/about/sub-header.vue'
  import AboutLinkBtnWrap from '~/components/about/link-btn-wrap.vue'

  export default {
    name: 'Partner',
    components: {
      AboutSubHeader,
      AboutLinkBtnWrap,
    },
    layout: 'template-page',
    data() {
      return {
        partnerList: [],
      }
    },
    fetchOnServer: false,
    async fetch() {
      try {
        await this.initMain()
      } catch (error) {
        console.log('fetch error: ', error)
      }
    },
    head() {
      return {
        title: '合作伙伴_问卷网',
      }
    },
    // mounted() {
    //   this.initMain()
    // },
    methods: {
      async initMain() {
        //  获取接口参数获取合作伙伴列表
        try {
          const { data } = await getPartnerList()
          console.log('getPartnerList', data)
          const { partner_list: partnerList = [] } = data || {}
          this.partnerList = partnerList
        } catch (error) {
          return Promise.reject(error)
        }
      },
      // 跳转路由
      jump(url, query) {
        if (!url) {
          return
        }
        this.$open(url, query)
      },
    },
  }
